import React from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import CouponTable from './components/CouponTable'
import CouponForm from './components/CouponForm'

// Breadcrumbs
const crmBreadcrumb: PageLink = {title: 'CRM', path: '/', isSeparator: false, isActive: false}
const crmCouponBreadcrumb: PageLink = {
  title: 'Coupon',
  path: '/crm/coupon',
  isSeparator: false,
  isActive: true,
}

function CouponPage() {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb]}>Coupon</PageTitle>
              <CouponTable />
            </>
          }
        />

        <Route
          path='/add'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmCouponBreadcrumb]}>Add Coupon</PageTitle>
              <CouponForm />
            </>
          }
        />

        <Route
          path='/edit/:id'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmCouponBreadcrumb]}>Edit Coupon</PageTitle>
              <CouponForm />
            </>
          }
        />
      </Route>

      {/* Page Not Found */}
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export default CouponPage
